export default {
  "checkbox": "_checkbox_jh49kv"
};